<template>
  <v-card v-if="item" class="white vetalfa-view" :max-width="_getMaxWidth()">
    <div class="vetalfa-header" ref="screenHeader">
      <vetalfa-small-header
        hasShareOption
        :title="topic ? topic.name : ''"
      ></vetalfa-small-header>
      <vetalfa-drugs-header
        :isDrugsMode="true"
        :name="item.name"
        :references="item.references"
        :description="getDescription()"
        v-on:resize="setupScreenSizes()"
      ></vetalfa-drugs-header>
    </div>
    <div ref="screenContent">
      <v-row class="ma-0 pa-0">
        <v-slide-group
          class="ml-2 mb-5"
          :show-arrows="!$vuetify.breakpoint.xsOnly && !_isCordovaApp()"
        >
          <v-slide-item v-for="reference in internalRefs" :key="reference.name">
            <v-card
              @click="openReferenceCard(reference)"
              height="70px"
              width="200px"
              class="vetalfa-pointer ma-0 my-2 pa-2 mr-2 vetalfa-card-border-item"
              outlined
            >
              <v-row aling="center" class="ma-0 pa-0 vetalfa-row">
                <v-col class="ma-0 pa-0" cols="2">
                  <v-img
                    contain
                    :src="getImageForRef(reference)"
                    height="20"
                    max-width="20"
                  ></v-img>
                </v-col>
                <v-col class="ma-0 pa-0" cols="9">
                  <p v-bind:class="getCarouselItemClass(reference)">
                    {{ reference.name }}
                  </p>
                  <p class="ma-0 pa-0 items-description-label">
                    {{ reference.category }}
                  </p>
                </v-col>
                <v-col class="ma-0 pa-0" cols="1">
                  <v-row
                    justify="end"
                    align="center"
                    class="ma-0 pa-0 vetalfa-row"
                  >
                    <v-icon x-small color="#747678">{{
                      mdiChevronRight
                    }}</v-icon>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-row>
      <vetalfa-general-tab
        v-if="!item.tree"
        :sections="itemSections"
        :references="item.references"
        :topicName="topic ? topic.name : null"
        :itemName="item.name"
        topics
        class="ma-0 pa-0"
      ></vetalfa-general-tab>
      <div v-else>
        <v-timeline
          id="vetalfa-algorithms-timeline"
          class="ma-0 pa-0"
          align-top
          dense
        >
          <algorithm-node
            v-for="node in nodes"
            :key="`algorithm-node-${node.level}`"
            :level="node.level"
            :headerHeightOffset="headerHeightOffset"
            class="ma-0 pa-0 py-2"
          ></algorithm-node>
        </v-timeline>
        <div class="navigation-blank-space"></div>
        <vetalfa-references-dialog></vetalfa-references-dialog>
      </div>
    </div>
  </v-card>
</template>

<style>
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 16px;
  top: var(--pseudo-timeline-top);
  right: initial;
  height: var(--pseudo-timeline-height);
}
.v-timeline--dense .v-timeline-item {
  padding-left: 8px !important;
}
.v-timeline--dense .v-timeline-item__body {
  max-width: 100%;
}
.v-timeline-item__divider {
  min-width: 16px;
}
.v-timeline-item__dot--small {
  height: 16px;
  width: 16px;
  margin-top: 2px;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AlgorithmNode from "../components/AlgorithmNode.vue";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import { mdiChevronRight } from "@mdi/js";
import sectionsEnum from "@/constants/sections.enum.js";
export default {
  components: {
    "algorithm-node": AlgorithmNode,
    "vetalfa-references-dialog": ReferencesDialog,
  },
  name: "Item",
  data() {
    return {
      headerHeightOffset: null,
      mdiChevronRight,
      sections: sectionsEnum.sections,
    };
  },
  computed: {
    ...mapGetters("algorithms", ["nodes"]),
    ...mapGetters("topics", ["item", "topic", "clickedReferences"]),
    internalRefs() {
      let arr = [];
      this.item.references.forEach((r) => {
        let hasRef = arr.find((i) => {
          return i.name === r.name;
        });
        if (!!r.type && r.type == 1 && !hasRef) {
          arr.push({
            ...r,
            category: r.category.replace("| Doses", "").trim(),
            path: r.path.split("/doses/")[0],
          });
        }
      });
      return this._shuffle(arr);
    },
    itemSections() {
      return !!this.item && !!this.item.sections ? this.item.sections : [];
    },
  },
  methods: {
    ...mapActions("topics", ["openTopicItem"]),
    ...mapActions("general", ["routePathRedirect", "logEvent"]),
    ...mapMutations("topics", ["setClickedReferences"]),
    getDescription() {
      if (!!this.item.description) {
        return this.item.description;
      } else if (!!this.item.categories && this.item.categories.length > 0) {
        return this.item.categories.join(" | ");
      }
      return this.topic ? this.topic.name : "";
    },
    setupScreenSizes() {
      this._setupScreenSizes(this);
      this.headerHeightOffset = this.$refs.screenHeader.offsetHeight;
    },
    getCarouselItemClass(reference) {
      return (
        (!!reference.description &&
        reference.description.trim() !=
          this._getLabel("ACTIVE_PRINCIPLE_SINGULAR") &&
        !reference.category.includes(this._getLabel("CALCULATORS"))
          ? "items-products-title"
          : "items-title") + " ma-0 pa-0 items-two-lines-clamp"
      );
    },
    openReferenceCard(reference) {
      this.logEvent("openCarouselReference");
      this.routePathRedirect({
        path: reference.path,
        from: { ...this.$route },
      });
    },

    getImageForRef(reference) {
      return this.sections.find((s) => {
        return (
          s.name.replace("e Escores", "").trim() ===
          reference.category.replace("| Doses", "").trim()
        );
      }).image;
    },
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (!!this.item && this.item.id != id) {
          this.openTopicItem({ itemId: id }).then(() => {
            this.setupScreenSizes();
            this._scrollToZero(this);
          });
        }
      },
      deep: true,
      immediate: false,
    },
  },
  async mounted() {
    if (this.$route.params["id"]) {
      await this.openTopicItem({ itemId: this.$route.params["id"] });
    }
    const arr = [].concat(this.clickedReferences);
    this.setClickedReferences([]);
    this.setClickedReferences(arr);
    this.setupScreenSizes();
  },
};
</script>
